// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2l0qM","question":"Question_question__2E8bS","description":"Question_description__fOetD"};